var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#9BA0B1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22C3.358 22 0 18.642 0 14.5c0-2.454 1.178-4.632 3-6v-6c0-1.104.89-2 1.997-2h15.006C21.106.5 22 1.396 22 2.5v15.28c0 1.108-.733 1.489-1.637.852L15.21 15h-.226c-.258 3.909-3.51 7-7.484 7zm8.343-9l4.172 2.94L20 2.5H4.997L5 7.427C5.78 7.151 6.623 7 7.5 7c3.628 0 6.655 2.577 7.35 6h.993zM7.5 20c3.038 0 5.5-2.462 5.5-5.5S10.538 9 7.5 9 2 11.462 2 14.5 4.462 20 7.5 20zm-1.707-2.293l-2-2c-.39-.39-.39-1.024 0-1.414.39-.39 1.024-.39 1.414 0l1.305 1.304 3.28-3.304c.391-.39 1.025-.39 1.415 0 .39.39.39 1.024 0 1.414l-4 4c-.39.39-1.024.39-1.414 0z",
    transform: "translate(-454 -444) translate(454 444)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInit);
export default __webpack_public_path__ + "static/media/init.8418808e77d31b8e06d0d7439652cedf.svg";
export { ForwardRef as ReactComponent };